import {
  FETCH_ALL_GOAL_CONTENT,
  FETCH_FEATURE_FLAGS,
  UPDATE_FEATURE_FLAG,
} from '../constants/ActionTypes';

const INITIAL_STATE = { goalContents: null, featureFlags: null };

export default function goalContentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_GOAL_CONTENT:
      return { ...state, goalContents: [...(action.payload || [])] };
    case FETCH_FEATURE_FLAGS:
      return { ...state, featureFlags: [...(action.payload || [])] };
    case UPDATE_FEATURE_FLAG:
      return {
        ...state,
        featureFlags: (state.featureFlags || []).map((f) => (f.key === action.payload.key ? action.payload : f)),
      };
    default:
      return state;
  }
}
